export class ColorTheme {
  
  constructor(
    public colorPrimary: string = '#5e8d93',
    public colorSecondary: string = '#eb9f12',
    public colorTertiary: string = '#eb9f12',
    public colorSuccess: string = '#10dc60',
    public colorWarning: string = '#eb9f12',
    public colorDanger: string = '#f53d3d'
  ) {}
  
}